var nurseslounge_articles = {
    init:function($params){
        var $userId = libs.memoryGet('user_id');
        $params = {user_id:$userId};
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_articles.menu_selector(function(){
            nurseslounge_articles.articles($params);
        });
    },
    menu_selector:function(cback){
        $("footer").hide();
        libs.globalUrl();
        cback();
    },
    articles:function($params){
        var $cards = $("#nurseslounge-articles .nurseslounge-articles-cards");
        var $articles = $("#nurseslounge-articles");
        var $main = $articles.find(".nurseslounge-articles-main");
        var $category = $main.find('select[name="category"]');
        $category.chosen();
        var $chtml = nurseslounge_articles.articles_html_preview();
        $cards.html($chtml).promise().done(function(){
            nurseslounge_articles.articles_request($params, function($data){
                var $chtml = nurseslounge_articles.articles_html($data);
                libs.checkImageLoad($($chtml).find('img'), function(){
                    $cards.html($chtml).promise().done(function(){
                        nurseslounge_articles.articles_events();
                    });
                });
            });
        });
    },
    articles_request:function($params, cback){
        $.ajax({
            url: "/articles/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback($data);
                }
            }
        });
    },
    articles_html_preview:function(){
        var $chtml = '';
        for(var $i=0; $i<2; $i++){
            $chtml += '' +
                '<div class="col-6 item float-left">' +
                '    <div class="card article-card mb-4">' +
                '        <div class="article-card-image nurseslounge-articles-preload">' +
                '           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '        <div class="d-flex p-3">' +
                '            <div class="profile-img mr-3 nurseslounge-articles-preload">' +
                '               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '            </div>' +
                '            <div class="list-info align-self-center w-100">' +
                '                <p class="nurseslounge-articles-preload">' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </p>' +
                '            </div>' +
                '        </div>' +
                '        <div class="article-card-desc px-3 nurseslounge-articles-preload">' +
                '            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '        <div class="article-card-tags px-3 nurseslounge-articles-preload">' +
                '           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '        <div class="total-likes float-right px-5 nurseslounge-articles-preload">' +
                '           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '    </div>' +
                '</div>';
        }
        return $chtml;

    },
    articles_html:function($data){
        var $chtml = '<div class="row m-0">';
        $.each($data.data.group, function($i, $v){
        var $articles = $v.articles;
        var $tag = $v.tag;
            $chtml += '' +
            '<div class="w-100 py-3 title">'+$tag+'('+$articles.length+')</div>' +
            '   <div class="row col-10 offset-1 carousel">';
            $.each($articles, function($articles_i, $articles_v){
                var $AF = $articles_v.article_features;
                var $date = $AF.updated_at ? $AF.updated_at : null;
                var $headline = $AF.headline && $AF.headline != '' ? $AF.headline: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
                var $_author = $AF.author && $AF.author != '' ? $AF.author: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
                var $wildcard = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
                var $description;
                if($AF.html && $AF.html != '' && $AF.html != null){
                    try{
                        $description = $($AF.html).text();
                    }catch ($e) {
                        $description = $AF.html;
                    }
                }else{
                    $description = $wildcard;
                }
                if($description != $wildcard){
                    $description = $description.length > 50 ? $description.substr(0, 50) + '...' : $description;
                }

                var $user = $articles_v.user;
                var $author = $user.long_name;
                var $jobTitle = $user && $user.job_title ? $user.job_title : '&nbsp;&nbsp;&nbsp;&nbsp;';
                var $authorLink = $user.profile_url;
                var $profileImage = $user.profile_image_root_wall + '?resize=46';

                var $imgOption1 = $AF && $AF.image && $AF.image.document_thumb_root ? $AF.image.document_thumb_root : null;
                var $imgOption2 = $articles_v.document_thumb_root;

                var $imageThumb = $imgOption1 != null ? $imgOption1 : $imgOption2;
                var $articleLikesCount = $articles_v.article_likes_count == 1  ? $articles_v.article_likes_count + ' like' : $articles_v.article_likes_count + ' likes';
                var $iAmOwner = $articles_v.i_am_owner;
                var $status = $AF.status;
                var $myLike = $articles_v.my_like ? 'like' : '';
                var $viewedByMe = $articles_v.viewed_by_me;
                var $documentId = $articles_v.id;
                var $expirationDate = $AF && $AF.expiration_date && $AF.expiration_date ? $AF.expiration_date : null;
                var $categories = $articles_v.article_categories ? $articles_v.article_categories : [];
                var $categoriesTxt = [];
                var $articleTags = [];
                if($AF && $AF.specialty && $AF.specialty.type) {
                    $articleTags.push({tag:$AF.specialty.type});
                }
                if($AF && $AF.degree && $AF.degree.subcategory){
                    $articleTags.push({tag:$AF.degree.subcategory});
                }
                $articleTags = $.merge($articleTags, $articles_v.article_tags);
                for (var $i in $categories){
                    $categoriesTxt.push($categories[$i].category.category);
                }
                $chtml += '' +
                    '<div class="col-12 item" ' +
                    '   data-id="'+$documentId+'" ' +
                    '   data-viewbyme="'+$viewedByMe+'" ' +
                    '   data-status="'+$status+'" ' +
                    '   data-iamowner="'+$iAmOwner+'" ' +
                    '>' +
                    '   <div class="card article-card mb-4">' +
                    '     <div class="article-card-image">' +
                    '         <img src="'+$imageThumb+'?resize=524x250" alt="article image" class="img-fluid">' +
                    '     </div>'+
                    '     <div class="d-flex p-3">' +
                    //'         <div class="profile-img mr-3">' +
                    //'            <a href="'+$authorLink+'" target="_blank">' +
                    //'                <img src="'+$profileImage+'" alt="profile">' +
                    //'            </a>' +
                    //'         </div>' +
                    //'         <div class="list-info align-self-center w-100">' +
                    //'            <a href="'+$authorLink+'" target="_blank">' +
                    //'                <h4>'+$author+'</h4>' +
                    //'                <h6>'+$jobTitle+'</h6>' +
                    //'            </a>' +
                    //'            <p>Published <span class="article-date" data-id="' + $documentId + '" data-articledate="' + $date + '"></span></p>' +
                    //'         </div>' +
                    '     </div>' +
                    '     <div class="article-card-desc px-3">' +
                    '         <h3>'+$headline+'</h3>' +
                    '         <p>' + $description + '</p>' +
                    '         <small>' + $_author + '</small>';
                if($expirationDate){
                    $expirationDate =  moment.utc($expirationDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
                    $chtml += '' +
                        '         <div class="small">Expire: ' + $expirationDate + '</div>';
                }else{
                    $chtml += '' +
                        '         <div class="small">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>';
                }
                if($categoriesTxt.length > 0){
                    $chtml += '' +
                        '         <div class="small">' + $categoriesTxt.join(', ') + '</div>';
                }else{
                    $chtml += '' +
                        '         <div class="small">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>';
                }
                $chtml += '' +
                    '         <button type="button" class="like-button ' + $myLike + ' m-3 float-right">' +
                    '             <i class="fa fa-heart"></i>' +
                    '         </button>' +
                    '     </div>' +
                    '     <div class="article-card-tags px-3">';
                $.each($articleTags, function($sI, $sV){
                    $chtml += '<div class="tag">' + $sV.tag + '</div>';
                });
                $chtml += '' +
                    '     </div>' +
                    '     <div class="total-likes float-right px-5">' +
                    $articleLikesCount +
                    '     </div>' +
                    '   </div>' +
                    '</div>';
            });
        $chtml += '' +
            '    </div>' +
            '</div>';
        });
        $chtml += '</div>';
        return $chtml;
    },
    articles_events:function(){
        var $carousels = $("#nurseslounge-articles .nurseslounge-articles-main .carousel");
        $carousels.unbind();
        $carousels.slick({
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        var $articles = $("#nurseslounge-articles");
        var $main = $articles.find(".nurseslounge-articles-main");
        var $items = $main.find(".item");
        var nlWallDocumentPreview = $(window).nurseslounge_myDashboard_wall_get({user_id:libs.memoryGet('user_id')}, 'nlWallDocumentPreview');
        $items.unbind().click(function(){
            if(libs.memoryGet('user_id') == 'guest'){
                public_nurseslounge_lounge_overview.login_popup({id:'articles'});
                return false;
            }
            var $that = $(this);
            var $documentId = $that.data('id');
            var $params = {
                document_id:$documentId,
                user_id:libs.memoryGet('user_id'),
            };
            nurseslounge_myDashboard_myArticles.events_recently_viewed_request($params, function() {
                nlWallDocumentPreview.init($documentId);
            });
        });
        var $likeButton = $items.find('.like-button');
        $likeButton.unbind().click(function($e){
            $e.stopPropagation();
            $e.preventDefault();
            var $that = $(this);
            var $like = !$that.hasClass('like');
            var $item = $that.parents('.item:first');
            var $documentId = $item.data('id');
            var $params = {
                document_id:$documentId,
                user_id:libs.memoryGet('user_id'),
                like:$like,
            };
            nurseslounge_myDashboard_myArticles.events_like_request($params, function($data){
                if($data.data.like){
                    $main.find('.item[data-id="'+$documentId+'"]').each(function(){
                        $(this).find('.like-button:first').addClass('like');
                    });
                }else{
                    $main.find('.item[data-id="'+$documentId+'"]').each(function(){
                        $(this).find('.like-button:first').removeClass('like');
                    });
                }
                var $likes = $data.data.likes == 1 ? $data.data.likes+' like' : $data.data.likes + ' likes';
                $main.find('.item[data-id="'+$documentId+'"]').each(function(){
                   $(this).find('.total-likes:first').html($likes);
                });
            });
        });
        var $category = $main.find('select[name="category"]');
        $category.unbind().change(function(){
            var $params = $.extend({}, {user_id:libs.memoryGet('user_id'), categories:$category.val()});
            nurseslounge_articles.articles($params);
        });
        var $search = $main.find('input[name="search"]');
        var $bindSearch;
        $search.unbind().on('keyup keydown keypress', function(){
            try{
                clearTimeout($bindSearch);
            }catch ($e) {

            }
            $bindSearch = setTimeout(function(){
                var $params = $.extend({}, {user_id:libs.memoryGet('user_id'), search:$search.val()});
                nurseslounge_articles.articles($params);
            }, 2000);
        });
        nurseslounge_articles.articles_autocomplete(
            $search,
            {user_id:libs.memoryGet('user_id')},
            "/articles/autocomplete",
            function($keyword){
                try{
                    clearTimeout($bindSearch);
                }catch ($e) {

                }
                var $params = $.extend({}, {user_id:libs.memoryGet('user_id'), search:$keyword});
                nurseslounge_articles.articles($params);
            }
        );
        //Realtime Clock
        var $articlesIds = [];
        $items.each(function(){
            var $that = $(this);
            $articlesIds.push($that.data('id'));
        });
        $articlesIds.sort();
        $articlesIds = $.unique($articlesIds);
        nurseslounge_articles.set_articles_dates($articlesIds);
        nurseslounge_articles.articles_date();
        $(window).on('resize orientationchange', function() {
            nurseslounge_articles.articles_events();
        });
    },
    articles_autocomplete:function($target, $data, $url, cback){
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $value = '';
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({},{
                        keyword:$($target).val()
                    }, $data),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $value = '';
                        response($data);
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value);
                cback($value);
                return false;
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                cback($(this).val());
                $(this).autocomplete("close");
            }
        });
    },
    articles_dates:[],
    articles_dates_binding:null,
    server_date_helper:null,
    server_date:null,
    set_server_date:function($serverDate){
        this.server_date_helper = new Date();
        this.server_date = new Date($serverDate);
    },
    get_server_date:function(){
        var $now  = new Date().getTime();
        var $diff = $now - this.server_date_helper.getTime();
        var $date = this.server_date.getTime() + $diff;
        return new Date($date);
    },
    set_articles_dates:function($articlesIds){
        this.articles_dates = $articlesIds;
    },
    get_articles_dates:function(){
        return this.articles_dates;
    },
    articles_date:function(cback){
        var $artcilesDate = libs.memoryGet('articles_date');
        if($artcilesDate){
            try{
                $artcilesDate.abort();
            }catch($e){

            }
        }
        $artcilesDate = $.ajax({
            url:location.href,
            method: "GET",
            cache:false,
            dataType: "html",
            success: function ($data, $status, $response) {
                var $dateString = $response.getResponseHeader('date');
                if ($dateString.indexOf('GMT')) {
                    $dateString = $dateString.replace('GMT','');
                }
                nurseslounge_articles.set_server_date($dateString);
                nurseslounge_articles.articles_date_html();
                if(cback != undefined){
                    cback();
                }
            }
        });
        libs.memorySave('articles_date', $artcilesDate);
    },
    articles_date_html:function(){
        var $refreshEverySeconds = 1;
        var $now = nurseslounge_articles.get_server_date().getTime();
        var $articlesDates = nurseslounge_articles.get_articles_dates();
        for(var $i in $articlesDates){
            var $key = $articlesDates[$i];
            $(document).find('.article-date[data-id="'+$key+'"]').each(function () {
                var $ele = $(this);
                if($ele.length > 0){
                    var $val = $ele.data('articledate');
                    var $newDate = $val.split(' ');
                    var $yearMonthDay = $newDate[0];
                    $yearMonthDay = $yearMonthDay.split('-');
                    var $HourMinuteSecond = $newDate[1];
                    $HourMinuteSecond = $HourMinuteSecond.split(':');
                    var $date = new Date($yearMonthDay[0], $yearMonthDay[1] - 1, $yearMonthDay[2], $HourMinuteSecond[0], $HourMinuteSecond[1], $HourMinuteSecond[2]);
                    var $second = $date.getSeconds();
                    $second = $second <= 9 ? '0' + $second : $second;
                    var $minute = $date.getMinutes();
                    $minute = $minute <= 9 ? '0' + $minute : $minute;
                    var $hour = $date.getHours();
                    $hour = $hour <= 9 ? '0' + $hour : $hour;
                    var $day = $date.getDate();
                    $day = $day <= 9 ? '0' + $day : $day;
                    var $month = $date.getMonth() + 1;
                    $month = $month <= 9 ? '0' + $month : $month;
                    var $year = $date.getFullYear();
                    var $articleDate =  $year + '-' + $month + '-' + $day + ' ' + $hour + ':'+ $minute + ':' + $second;
                    $date = $date.getTime();
                    var $diffSeconds = Math.floor(($now - $date)/1000);
                    var $diffMinutes = Math.floor($diffSeconds/60);
                    var $diffHours = Math.floor($diffMinutes/60);
                    var $diffDays = Math.floor($diffHours/24);
                    var $chtml = '';
                    if($diffDays == 0 && $diffHours == 0 && $diffMinutes == 0){
                        $chtml = $diffSeconds == 1 ? $diffSeconds + ' second ago' : $diffSeconds + ' seconds ago';
                    }else
                    if ($diffDays == 0 && $diffHours == 0){
                        $chtml = $diffMinutes == 1 ? $diffMinutes + ' minute ago' : $diffMinutes + ' minutes ago';
                    }else
                    if ($diffDays == 0){
                        $chtml = $diffHours == 1 ? $diffHours + ' hour ago' : $diffHours + ' hours ago';
                    }else
                    if($diffDays < 4){
                        $chtml = $diffDays == 1 ? $diffDays + ' day ago' : $diffDays + ' days ago';
                    }else{
                        $date = $ele.data('articledate');
                        $chtml =  moment.utc($date, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A');
                    }
                    if($ele.html() != $chtml){
                        $ele.data('articledate', $articleDate).html($chtml);
                    }
                }
            });
        }
        try{
            clearTimeout(this.articles_dates_binding);
        }catch($e){}
        this.articles_dates_binding = setTimeout(function(){
            nurseslounge_articles.articles_date_html();
        }, ($refreshEverySeconds * 1000));
    },
};
